import * as React from 'react';
import { Button, Card } from 'react-bootstrap';
import classes from './EventDateTimeLocationSocialsCard.module.css';
import { formatSingleDate, formatTimeRange } from 'shared-front-end';
import { EventExtendedViewRow } from 'cb-model';

interface EventDateTimeLocationSocialsCardProps {
  event: EventExtendedViewRow;
}

export const EventDateTimeLocationSocialsCard = (props: EventDateTimeLocationSocialsCardProps): React.JSX.Element => {
  const eventUrl = window.location.href;
  const message = `Check out this event on Careerbook! ${eventUrl}`;

  const sharePlatforms = {
    facebook: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(eventUrl)}&quote=${encodeURIComponent(
      message,
    )}`,
    twitter: `https://twitter.com/intent/tweet?text=${encodeURIComponent(message)}`,
    whatsapp: `https://api.whatsapp.com/send?text=${encodeURIComponent(message)}`,
  };

  return (
    <Card>
      <Card.Body className={classes.EventDateTimeLocationSocialsCard}>
        <div className={classes.EventDateTimeLocation}>
          <div>
            <img src="/assets/icons/calendar.svg" alt="calendar icon" />
            <span>
              {props.event.start_at ? formatSingleDate(new Date(props.event.start_at), false) : 'Available On-Demand'}
            </span>
          </div>

          <div>
            <img src="/assets/icons/clock.svg" alt="clock icon" />
            <span>{props.event.start_at ? formatTimeRange(props.event.start_at, props.event.end_at) : 'All day'}</span>
          </div>

          <div>
            <img src="/assets/icons/map-pin.svg" alt="location icon" />
            <span>{props.event.location || 'Online'}</span>
          </div>
        </div>

        <div className={classes.Socials}>
          <a target="_blank" href={sharePlatforms.facebook}>
            <img src="/assets/icons/social-media-logo-facebook.svg" alt="facebook icon" />
          </a>
          <a target="_blank" href={sharePlatforms.twitter}>
            <img src="/assets/icons/social-media-logo-x.svg" alt="twitter icon" />
          </a>
          <a target="_blank" href={sharePlatforms.whatsapp}>
            <img src="/assets/icons/social-media-logo-whatsapp.svg" alt="whatsapp icon" />
          </a>
        </div>
      </Card.Body>
    </Card>
  );
};
